module.exports = __webpack_public_path__ + "static/vista-explodida-4-en-4646d78a3f9b4a93fce0e7a29959908e.png";